import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReduxCheck } from '../redux-check/ReduxCheck';
import { Card } from '../card';
import { Loader } from '../loader';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../footer/Footer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setAppToken } from '../auth/authSlice';

import axios from 'axios';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../loader/loaderSlice';


const MainPage = (props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	
	const verifyJwt = () => {
		const jwt = searchParams.get("token");
		console.log(jwt);

		const reqBody = {
            "token" : jwt
        }

        // dispatch(showLoader());
        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/verify-token`, reqBody, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
            .then((response) => {
                console.log(response);
				// dispatch(hideLoader());

				if(response.data.status === 'success'){
					dispatch(setAppToken(response.data.token));
				}
				else {
					navigate("/error");
				}
				

            })
            .catch((error) => {
                // handle errors
                console.log(error);
				// dispatch(hideLoader());
                
            });

	}

	// verifyJwt();

	return (
		<div className="app-page">
			{ 
				!props.noheader && 
				<div className="title-page"> 
				<Container>
					<Row>
						<Col xs={2}>
							<img src="./333-logo.png" alt="Logo" />
						</Col>
						<Col xs={8}>
							<h2 align="center">POC First Phase</h2>
						</Col>
						<Col xs={2}>
						
						</Col>
						
					</Row>
				</Container>
					
				</div>
			}
			<Loader />
			<Card />
			<Footer />
		</div>
	);
};

export default MainPage;